import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';
import { useNavigate } from 'react-router-dom';

type LoginPromptProps = { className?: string };

const LoginPrompt = ({ className = '' }: LoginPromptProps) => {
  const navigate = useNavigate();

  return (
    <div className={`flex h-40 items-center justify-center gap-4 p-4 lg:flex-wrap ${className}`}>
      <div className='flex flex-col items-center gap-1 lg:gap-2 md:w-full'>
        <p className='text-center text-xs font-semibold'>
          メッセージを投稿するにはログインが必要です。
        </p>
        <div className='w-[300px] md:w-full md:max-w-[280px]'>
          <Button
            size='s'
            fullRounded
            fullWidth
            onClick={() => navigate(COMPANY_URL.REGISTRATION)}
          >
            新規会員登録
          </Button>
        </div>
      </div>

      <div className='flex flex-col items-center gap-1 md:w-full md:gap-2'>
        <p className='text-xs'>すでにアカウントをお持ちの方</p>
        <div className='w-[300px] md:w-full md:max-w-[280px]'>
          <Button
            size='s'
            fullRounded
            fullWidth
            outline
            onClick={() => navigate(COMPANY_URL.LOGIN)}
          >
            ログイン
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;
